import { authHeaders, client } from '../../_shared/services/openapiClient';
import type { components, paths } from '../../../types/schema';

export type UserBinder = components['schemas']['ApiV1UserBinder'];
export type GetUserBindersResponse =
  paths['/api/v1/user_binders']['get']['responses'][200]['content']['application/json']['userBinders'];
export type SaveUserBinderResponse =
  paths['/api/v1/user_binder']['post']['responses'][201]['content']['application/json']['userBinder'];
export type UpdateUserBinderResponse =
  paths['/api/v1/user_binder']['patch']['responses'][200]['content']['application/json']['userBinder'];
export type UserBinderMap = Record<string, UserBinder>;

type GetUserBindersParams = {
  artistId?: string;
  memberId?: string;
};

export async function getUserBinders({
  artistId,
  memberId
}: GetUserBindersParams = {}): Promise<GetUserBindersResponse> {
  const { data, error } = await client.GET('/api/v1/user_binders', {
    params: {
      query: {
        artist_id: artistId || undefined,
        member_id: memberId || undefined
      }
    },
    headers: authHeaders()
  });

  if (error) throw error;
  if (!data) throw new Error('Empty response from getUserBinders');

  return data.userBinders;
}

export function mapUserBindersByMemberId(userBinders: GetUserBindersResponse): UserBinderMap {
  return Object.fromEntries(
    userBinders
      .filter((userBinder) => !!userBinder?.memberId)
      .map((userBinder) => [userBinder.memberId, userBinder])
  );
}

export async function saveUserBinder(
  artistId: string,
  memberId: string,
  dataUrl: string,
  shouldUpdate = false
): Promise<SaveUserBinderResponse | UpdateUserBinderResponse> {
  const requestBody = {
    user_binder: {
      artist_id: artistId,
      member_id: memberId,
      data_url: dataUrl
    }
  };

  const { data, error } = shouldUpdate
    ? await client.PATCH('/api/v1/user_binder', {
        body: requestBody,
        headers: authHeaders()
      })
    : await client.POST('/api/v1/user_binder', {
        body: requestBody,
        headers: authHeaders()
      });

  if (error) throw error;
  if (!data) throw new Error('Empty response from saveUserBinder');

  return data.userBinder;
}
